import { datasetsClient } from "../../sdk";
import {
  DatasetFileTypeGroup,
  DatasetLicenseGroup,
  DatasetListItem,
  DatasetSelectionGroup,
  DatasetSizeGroup,
  DatasetSortBy,
} from "./commonModels";

export interface Response {
  // TODO(cochamberlain): Make this return DatasetListItemReference[];
  datasetListItems: DatasetListItem[];
  totalDatasetListItems: number;
}

export interface Request {
  search: string;
  group: DatasetSelectionGroup;
  fileType: DatasetFileTypeGroup;
  license: DatasetLicenseGroup;
  size: DatasetSizeGroup;
  sortBy: DatasetSortBy;
  page: number;
  categoryIds: number[];
}

// TODO(cochamberlain): Get a new simplified handler out in front of this that
// combines results from db and search service.
export const searchDatasets = async (request: Request): Promise<Response> => {
  const response = await datasetsClient.searchDatasets({
    ...request,
    userId: null,
    competitionId: null,
    organizationId: null,
    maintainerOrganizationId: null,
    isUserQuery: false,
    viewed: "all",
    minSize: null,
    maxSize: null,
    hasTasks: false,
    topicalDataset: null,
    includeTopicalDatasets: false,
  });

  // HACK(cochamberlain): Translate to what we need.
  const datasetListItems = response.datasetList?.items.map(item => {
    const { voteButton } = item;

    if (voteButton === null) {
      throw new Error("DatasetListItem should have voteButton.");
    }

    return {
      ...item,
      datasetVersionId: item.currentDatasetVersionId,
      datasetVersionNumber: item.currentDatasetVersionNumber,
      id: item.datasetId,
      dateUpdated: new Date(item.dateUpdated),
      datasetUrl: item.datasetUrl as string,
      datasetSlug: item.datasetSlug as string,
      ownerAvatarUrl: item.ownerAvatarUrl as string,
      ownerName: item.ownerName as string,
      ownerUrl: item.ownerUrl as string,
      creatorName: item.creatorName as string,
      creatorUrl: item.creatorUrl as string,
      scriptsUrl: item.scriptsUrl as string,
      forumUrl: item.forumUrl as string,
      voteButton: {
        ...voteButton,
        voteUpUrl: voteButton.voteUpUrl as string,
        voteDownUrl: voteButton.voteDownUrl as string,
      },
      tags: item.categories,
      datasetSize: item.datasetSize as number,
    };
  });

  return {
    datasetListItems: datasetListItems || [],
    totalDatasetListItems: response.datasetList?.totalResults || 0,
  };
};
